import { hc } from "hono/client";
import type { AppType } from "@app/server-core";
import { apiFetch } from "./rateLimitNotice";

// No baseURL — same-origin requests through the /api dev proxy (and for any
// future same-origin deployment), consistent with auth-client.ts.
// fetch: 모든 RPC 요청을 429 감지 래퍼로 감싼다 — 서버 rate limit 에 걸리면
// 여기 한 곳에서 안내 토스트를 띄운다(rateLimitNotice.ts).
export const apiClient = hc<AppType>("/", {
  init: { credentials: "include" },
  fetch: apiFetch,
});
